<template>
	<ConfirmationDialog class="unarchive-goal-prompt">
		<template #header>
			<h1 class="unarchive-goal-prompt__heading">{{ $t( "common-gokr.components.UnarchiveGoalPrompt.title" ) }}</h1>
		</template>
		<template #description>
			<main class="unarchive-goal-prompt__main">
				{{ $t( "common-gokr.components.UnarchiveGoalPrompt.description" ) }}
			</main>
		</template>
		<template #actions>
			<footer class="unarchive-goal-prompt__footer">
				<TeamingButton
					size="SMALL"
					type="PRIMARY"
					:destructive="true"
					@click="$emit( `confirm` )"
				>
					{{ $t( "common-gokr.components.UnarchiveGoalPrompt.confirmButton" ) }}
				</TeamingButton>
				<TeamingButton
					size="SMALL"
					type="QUATERNARY"
					@click="$emit( `dismiss` )"
				>
					{{ $t( "common-gokr.components.UnarchiveGoalPrompt.dismissButton" ) }}
				</TeamingButton>
			</footer>
		</template>
	</ConfirmationDialog>
</template>

<script>
import { ConfirmationDialog, TeamingButton } from "@teaming/common-ui";
export default {
	name: "UnarchiveGoalPrompt",
	emits: [ "confirm", "save", "dismiss", ],
	components: {
		ConfirmationDialog,
		TeamingButton,
	},
};
</script>

<style lang="scss" scoped>
$unarchive-goal-prompt-title-color: $color1-700;

.unarchive-goal-prompt__heading {
	@include font-and-line-for(1);
	font-weight: 600;
	color: $unarchive-goal-prompt-title-color;
}

.unarchive-goal-prompt__footer {
	display: flex;
	flex-direction: row;
	justify-content: flex-start;
	gap: 1rem;
}
</style>
